import React, { createElement } from 'react';
import { View } from 'react-native';

/** Official-style Google “G” for web SSO. */
export function GoogleIcon({ size = 18 }: { size?: number }) {
  return (
    <View style={{ width: size, height: size }}>
      {createElement(
        'svg',
        { width: size, height: size, viewBox: '0 0 48 48', 'aria-hidden': true },
        createElement('path', {
          fill: '#FFC107',
          d: 'M43.6 20.1H42V20H24v8h11.3C33.7 32.7 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.1 8 3.1l5.7-5.7C34.2 6.1 29.4 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.7-.4-3.9z',
        }),
        createElement('path', {
          fill: '#FF3D00',
          d: 'M6.3 14.7l6.6 4.8C14.7 16.1 19 13 24 13c3.1 0 5.8 1.1 8 3.1l5.7-5.7C34.2 6.1 29.4 4 24 4 16.3 4 9.7 8.3 6.3 14.7z',
        }),
        createElement('path', {
          fill: '#4CAF50',
          d: 'M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.3 35.3 26.8 36 24 36c-5.3 0-9.7-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z',
        }),
        createElement('path', {
          fill: '#1976D2',
          d: 'M43.6 20.1H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4.1 5.5l.1.1 6.2 5.2C39.2 36.3 44 31 44 24c0-1.3-.1-2.7-.4-3.9z',
        }),
      )}
    </View>
  );
}
